import React from 'react';
import { motion } from 'framer-motion';
import { EASE_OUT } from '../../utils/motion';
type SplitTextProps = {
  text: string;
  delay?: number;
  stagger?: number;
};
export function SplitText({
  text,
  delay = 0,
  stagger = 0.045
}: SplitTextProps) {
  const words = text.split(' ');
  return <>
      <span className="sr-only" data-id="element-418" data-mp="nkr6xj0witrn">{text}</span>
      <span aria-hidden="true" data-id="element-419" data-mp="nixzw2mdm7j4">
        {words.map((word, i) => <span key={`${word}-${i}`} className="inline-block overflow-hidden pb-[0.08em] align-top" data-id="element-420" data-mp="11b4g1opj4eik" data-mpi={i}>
            <motion.span className="inline-block" initial={{
          y: '105%'
        }} whileInView={{
          y: '0%'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: EASE_OUT,
          delay: delay + i * stagger
        }} data-id="element-421" data-mp="xa2gf6rpa0g2">
              {word}
              {i < words.length - 1 ? '\u00A0' : ''}
            </motion.span>
          </span>)}
      </span>
    </>;
}